export default {
    getFilterMB: state => state.filter,
    getDoctorsMB: state => state.doctors,
    getNursesMB: state => state.nurses,
    getActiveMessageMB: state => state.activeMessage,
    getSendMessageMB: state => state.sendMessage,
    getMessagesMB: state => state.messages,
}